export default __webpack_public_path__ + "static/media/warning--speed-camera--g1.c247454b.png";